export default __webpack_public_path__ + "static/media/SNP.1d23d9a5.svg";